import { Drawer, type DrawerProps } from "antd";
import clsx from "clsx";
import "./BDrawer.scss";

const SLOT_CLASS = {
  mask: "b-drawer__mask",
  content: "b-drawer__content",
  header: "b-drawer__header",
  body: "b-drawer__body",
  footer: "b-drawer__footer",
} as const;

const BDrawer = ({
  className,
  rootClassName,
  classNames,
  ...props
}: DrawerProps) => (
  <Drawer
    {...props}
    className={clsx("b-drawer", className)}
    rootClassName={clsx("b-drawer__root", rootClassName)}
    classNames={{
      mask: clsx(SLOT_CLASS.mask, classNames?.mask),
      content: clsx(SLOT_CLASS.content, classNames?.content),
      header: clsx(SLOT_CLASS.header, classNames?.header),
      body: clsx(SLOT_CLASS.body, classNames?.body),
      footer: clsx(SLOT_CLASS.footer, classNames?.footer),
    }}
  />
);

export default BDrawer;
